<div class="footer">
    <div class="container">
        <app-footer-top></app-footer-top>
        <app-footer-bottom></app-footer-bottom>
    </div>
</div>
